import axios from 'axios'

export const getApiErrorCode = (err: unknown): string | undefined => {
  if (axios.isAxiosError(err)) return err.response?.data?.error?.code

  return undefined
}
